import { render, staticRenderFns } from "./ListaModal.vue?vue&type=template&id=6b09a198&"
import script from "./ListaModal.vue?vue&type=script&lang=js&"
export * from "./ListaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports